import { useEffect, useState } from 'react';
import { mediaUrl } from '../api/client';

/** Circular avatar: shows the player's photo when available, else their initial.
 *  Used in the home header, the registered-players stack, and the profile. */
type AvatarProps = {
  name?: string | null;
  /** Photo URL (Telegram or our /api/avatars/:id). Falls back to the initial. */
  src?: string | null;
  size?: number;
  /** index in a stack → rotates accent background so overlapping circles read */
  variant?: number;
  bordered?: boolean;
};

// Ink stays navy in both themes (spot-dark per light.md §3); gold initial reads on it.
const BACKGROUNDS = ['var(--ink)', 'var(--gold)', 'var(--green)'];
const COLORS = ['var(--gold)', 'var(--gold-ink)', '#ffffff'];

export function Avatar({ name, src, size = 42, variant, bordered }: AvatarProps) {
  const initial = (name || '?').trim().charAt(0).toUpperCase() || '?';
  const i = variant === undefined ? -1 : variant % BACKGROUNDS.length;
  const background = i >= 0 ? BACKGROUNDS[i] : 'var(--ink)';
  const color = i >= 0 ? COLORS[i] : 'var(--gold)';

  const resolved = mediaUrl(src);
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [resolved]);

  return (
    <span
      className={`avatar${bordered ? ' avatar--bordered' : ''}`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.4), background, color }}
    >
      {resolved && !failed ? (
        <img src={resolved} alt={name ?? ''} onError={() => setFailed(true)} />
      ) : (
        initial
      )}
    </span>
  );
}
